// FE→BE seam for popular games shown on an empty mobile search.
// Server counterpart: app/api/casino/games/popular/route.ts
// Imports from `domain/` are type-only.
import type { PopularGamesResponse } from "@/domain/casino/listing/types"

const POPULAR_GAMES_ENDPOINT = "/api/casino/games/popular"

type PopularGamesRequestOptions = {
  signal?: AbortSignal
}

export async function fetchPopularGames(
  options: PopularGamesRequestOptions = {}
): Promise<PopularGamesResponse> {
  const response = await fetch(POPULAR_GAMES_ENDPOINT, {
    signal: options.signal
  })

  if (!response.ok) {
    throw new Error(`Popular games failed with status ${response.status}`)
  }

  return (await response.json()) as PopularGamesResponse
}
